// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .required {
  color: #ffcb37;
}
:host .submit {
  float: right;
}
:host .danger {
  color: red;
}
:host tr.header {
  background-color: var(--ion-color-primary);
  width: 100%;
  text-align: center;
  border: 0;
}
:host .end-input-icon {
  font-size: 18px;
  position: absolute !important;
  bottom: 9px !important;
  right: 5px;
  margin: 0 !important;
  min-height: 0 !important;
  color: #9e9e9e;
}
:host .end-input-spinner {
  position: absolute !important;
  bottom: 9px !important;
  right: 5px;
  margin: 0 !important;
  width: 18px;
  height: 18px;
}
:host .nav-bar-search-button {
  display: none;
}
:host .beer-name {
  font-weight: normal;
  font-size: 18px;
}
:host .brewery-name {
  font-size: 14px;
  /*0.8em;*/
}
:host .cant-find-brewery {
  position: absolute !important;
  left: -20px !important;
}
:host select-searchable-item-is-selected {
  color: blue;
  background-color: yellow !important;
}
:host .submit-button {
  margin-top: 20px;
}
:host .brewery-navigation {
  margin-top: -25px;
  margin-bottom: -10px;
}
:host .brewery-navigation-button {
  width: 30%;
}
:host .brewery-navigation-text {
  color: #9e9e9e;
  font-weight: bold;
}
:host #brewery-navigation-next {
  float: right;
}
:host .divider-text {
  font-size: 17px;
  font-weight: bold;
  color: #9e9e9e;
}
:host .brewery-name {
  font-weight: normal;
  font-size: 18px;
}
:host .country-name {
  font-size: 14px; /*0.8em;*/
}
:host .disabled {
  opacity: 0.4;
}
:host .item-md.item-input.ng-valid.input-has-value:not(.input-has-focus) .item-inner {
  border-bottom-color: transparent !important;
  box-shadow: inset 0 -1px 0 0 rgba(0, 0, 0, 0.1) !important;
}
:host #countryitem .invalid {
  border-bottom-color: #f53d3d !important;
  box-shadow: inset 0 -1px 0 0 #f53d3d !important;
}
:host .invalid {
  border-bottom-color: #f53d3d !important;
  box-shadow: inset 0 -1px 0 0 #f53d3d !important;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
